import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { ElasticSearchConfigModel } from "./elastic-search-config.model";

@Injectable({
    providedIn: 'root',
})
export class ElasticSearchService {
    private baseUrl: string = environment.baseApiUrl;
    private useTestElkConfig$ = new BehaviorSubject<boolean>(false);
    private useDisplayScoreElk$ = new BehaviorSubject<boolean>(false);
    private elasticSearchConfig$ = new BehaviorSubject<ElasticSearchConfigModel>(null);

    public notifyUseDisplayScoreElk(value: boolean) {
        return this.useDisplayScoreElk$.next(value);
    }

    public getUseDisplayScoreElk$() {
        return this.useDisplayScoreElk$.asObservable();
    }



    /**
     * Permet de récupérer la configuration de test
     * @param onValidate 
     */
    public getElasticSearchConfig$() {
        return this.elasticSearchConfig$.asObservable();
    }

    /**
     * Permet de notifier la configuration ElasticSearch
     * @param config
     */
    public notifyElasticSearchConfig(config: ElasticSearchConfigModel) {
        this.elasticSearchConfig$.next(config);
    }

    /**
     * Permet de setter un boolean pour indiquer si on on passe sur la configuration de test Elk
     * @param value 
     */
    public notifyUseTestElkConfig(value: boolean) {
        this.useTestElkConfig$.next(value);
    }

    public getUseTestElkConfig$(): Observable<boolean> {

        return this.useTestElkConfig$.asObservable();
    }

    public getTestConfig$(): Observable<ElasticSearchConfigModel> {
        return this.http.get<any>(`${this.baseUrl}/ElasticSearchConfig/Test`).pipe(map(response => {
            if (!response || response == null || !response.jsonConfig || response.jsonConfig == null) {
                throw new Error("No test configuration found");
            } else {
                let testConfigElk = JSON.parse(response.jsonConfig) as ElasticSearchConfigModel;
                this.notifyElasticSearchConfig(testConfigElk);
                return testConfigElk;
            }
        }))
    }

    public saveTestConfig$(config: ElasticSearchConfigModel): Observable<any> {

        const payload = {
            ...config,
            boostNameMatch: config.boostNameMatch?.toString(),
            boostNameMatchPrecise: config.boostNameMatchPrecise?.toString(),
            boostMatchBrand: config.boostMatchBrand?.toString(),
            boostMultiFieldProductType: config.boostMultiFieldProductType?.toString(),
            boostMultiFieldIngredient: config.boostMultiFieldIngredient?.toString(),
            boostMultiFieldNameMatchPrecise: config.boostMultiFieldNameMatchPrecise?.toString(),
            boostMultiFieldNBrand: config.boostMultiFieldNBrand?.toString(),
            boostMultiFieldEan: config.boostMultiFieldEan?.toString(),
            boostMultiFieldEanSuffixe: config.boostMultiFieldEanSuffixe?.toString(),
            boostMultiFieldProductCode: config.boostMultiFieldProductCode?.toString(),
            boostMultiFieldKiwiCode: config.boostMultiFieldKiwiCode?.toString(),
            boostFavorite: config.boostFavorite?.toString(),
            boostDiscount: config.boostDiscount?.toString(),
            boostNew: config.boostNew?.toString(),
            ownBrands: config.ownBrands.map(b => ({
                brandName: b.brandName,
                weight: b.weight?.toString()
            })),
            exclusiveBrands: config.exclusiveBrands.map(b => ({
                brandName: b.brandName,
                weight: b.weight?.toString()
            }))
        };

        const jsonString = JSON.stringify(payload); // simple JSON string

        return this.http.put(`${this.baseUrl}/ElasticSearchConfig/save/test`, { json: jsonString }).pipe(
            tap(() => this.notifyElasticSearchConfig(config))
        );
    }
    constructor(private http: HttpClient) { }
}
